import CryptoJS from 'crypto-js';
import { WalletCore } from '@halo/wallet-app';
import type { WalletInfo } from '.';

export const asymmetricEncryption = (message: string) => {
  return CryptoJS.SHA256(message).toString(CryptoJS.enc.Hex);
};

export const createWallet = async (params: { password: string }) => {
  const { password } = params;
  const newAccount = await WalletCore.createAccount({ password });

  const mnemonic = await WalletCore.getMnemonic({
    password,
    accountId: newAccount.id,
  });
  newAccount.name = 'Halo Wallet';
  newAccount.isDefault = true;
  newAccount.uid = CryptoJS.MD5(asymmetricEncryption(mnemonic.mnemonicOf12Bit)).toString();
  newAccount.clientUid = CryptoJS.MD5(
    asymmetricEncryption(mnemonic.mnemonicOf12Bit + 'EncryptedId')
  ).toString();
  return newAccount;
};

export const getWalletInfo = (newWalletData: Partial<WalletInfo>) => {
  const { accounts } = newWalletData;
  // TODO amo: Why not have default account?
  const account = accounts?.find((account) => account?.isDefault && account?.uid);

  const derivedAccount = account?.derivedWallets?.[0];

  return {
    ...newWalletData,
    uid: account?.uid,
    clientUid: account?.clientUid,
    accountId: derivedAccount?.id,
    walletAddresses: Object.values(derivedAccount?.seriesWallets || {})?.reduce(
      (addresses, wallet) => {
        return {
          ...addresses,
          [wallet.chainType]: (wallet as any).walletAddress,
        };
      },
      {}
    ),
  };
};
